import { useState } from 'react';
import { add_icon } from '../../assets/icons/icons';
import { message } from 'antd';
import {
  Container,
  ThemeTable,
  ThemeButton,
  AnnouncementDrawer,
} from '../../components/components';
import {
  useGetAnnouncementsQuery,
  useAddAnnouncementMutation,
} from '../../services/announcements';
import { NotificationFilled } from '@ant-design/icons';

const Announcements = () => {
  const [open, setOpen] = useState(false);
  const {
    data,
    refetch,
    isLoading: fetchingAnnouncements,
  } = useGetAnnouncementsQuery();
  const [addAnnouncement, { isLoading: submitting }] =
    useAddAnnouncementMutation();
  const [formData, setFormData] = useState({});

  const onClose = () => {
    setOpen(false);
    setFormData({});
  };

  const onSubmit = async () => {
    const response = await addAnnouncement({ announcement: formData });
    onClose();
    refetch();
    if (!response?.data?.error) {
      message.success('Announcement added successfully.');
      onClose();
      refetch();
    } else {
      message.error(response?.data?.msg || 'Something went wrong');
    }
  };

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      render: (data, _, index) => (
        <p className="text-center font-medium">{index + 1}</p>
      ),
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: title => <p className="text-center font-medium">{title}</p>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: description => (
        <p className="text-center font-medium">{description}</p>
      ),
    },
  ];

  return (
    <Container
      selected={'3'}
      header={
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="bg-primary h-9 w-9 rounded-full flex justify-center items-center">
              <NotificationFilled className="text-white" />
            </div>
            <p className="ml-2 font-semibold text-2xl">Announcements</p>
          </div>
          <div className="flex items-center">
            <ThemeButton
              className={'ml-3'}
              content={
                <div className="flex items-center">
                  <img src={add_icon} alt="" width={18} height={18} />
                  <p className="ml-2">Add Announcements</p>
                </div>
              }
              onClick={() => setOpen(true)}
            />
          </div>
        </div>
      }
    >
      <AnnouncementDrawer
        open={open}
        onClose={onClose}
        btnTxt={'Add Announcement'}
        addIcon={add_icon}
        onSubmit={onSubmit}
        isLoading={submitting}
        formData={formData}
        setFormData={e => setFormData(e)}
      />
      <ThemeTable
        columns={columns}
        data={data?.data || []}
        loader={fetchingAnnouncements}
        entityName="announcements"
        emptyText="No announcements yet. Post one to notify all owners in the app."
      />
    </Container>
  );
};

export default Announcements;
